import Vue from 'vue'
import Echo from 'laravel-echo'
import $ from 'jquery'

window.Pusher = require('pusher-js')

if (process.env.VUE_APP_WE_ENABLE === 'true') {
  Vue.prototype.$echo = new Echo({
    broadcaster: process.env.VUE_APP_WS_BROADCASTER,
    key: process.env.VUE_APP_WS_KEY,
    cluster: process.env.VUE_APP_WS_CLUSTER,
    wsHost: process.env.VUE_APP_WS_HOST,
    wsPort: process.env.VUE_APP_WS_PORT,
    wssPort: process.env.VUE_APP_WSS_PORT,
    forceTLS: process.env.VUE_APP_WS_FORCE_TLS,
    encrypted: process.env.VUE_APP_WS_ENCRYPTED,
    disableStats: process.env.VUE_APP_WS_DISABLE_STATS,
    authEndpoint: process.env.VUE_APP_API_URL + 'broadcasting/auth',

    authorizer: (channel, options) => {
      return {
        authorize: (socketId, _callback) => {
          $.ajaxSetup({
            crossDomain: true,
            xhrFields: {
              withCredentials: true
            }
          })
          $.post(process.env.VUE_APP_API_URL + 'broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
            xhrFields: {
              withCredentials: true
            }
          })
            .then(response => {
              _callback(false, response)
            })
            .catch(error => {
              console.log(error)
              _callback(true, error)
            })
        }
      }
    }
  })
}
